<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="w-full h-full flex-column">
    <div class="bold fs-24" style="margin-top: -100px">基础设置</div>
    <div class="flex flex-wrap" style="margin-top: 80px">
      <div @click="toLoginAccounts">
        <img class="w-100 h-100" src="../../assets/basesettings/ic_account@2x.png"/>
        <div class="w-100 text-center bold fs-14 margin-top-10">登录账户</div>
      </div>
      <div @click="onAccountEdit" style="margin-left: 120px">
        <img class="w-100 h-100" src="../../assets/basesettings/ic_company_info@2x.png"/>
        <div class="w-100 text-center bold fs-14 margin-top-10">企业信息</div>
      </div>
      <div @click="phoneVersionModal.show=true" style="margin-left: 120px">
        <img class="w-100 h-100" src="../../assets/basesettings/ic_phone@2x.png"/>
        <div class="w-100 text-center bold fs-14 margin-top-10">手机版本</div>
      </div>
      <div @click="consultantModal.show=true" style="margin-left: 120px">
        <img class="w-100 h-100" src="../../assets/basesettings/ic_professioal@2x.png"/>
        <div class="w-100 text-center bold fs-14 margin-top-10">专属顾问</div>
      </div>
    </div>
    <Modal :closable="true" class="modal-setting" footer-hide title="" v-model="phoneVersionModal.show" width="800px">
      <p class="text-center" slot="header">
        <span>{{ phoneVersionModal.title }}</span>
      </p>
      <div class="flex w-full" style="height: 536px;">
        <img src="../../assets/basesettings/img_shouji@2x.png"
             style="margin-left: 80px;margin-top: 80px;margin-right: 80px;">

        <div style="margin-right: 74px">
          <div class="fs-20 bold color-33" style="margin-top: 80px;">手机版</div>
          <div class="fs-14 m-t-15">
            智能可视化建站及小程序开发平台，轻松打造“pc网站、手机网站、微信小程序”等站点。
          </div>

          <img :src="getQrCode" alt=""
               style="margin-top: 60px;width: 128px">
          <div class="color-33 fs-12 text-center m-t-15" style="width: 128px;">
            扫码登录 <span @click="onQrcodeDownload" style="color: #1989FA;cursor: pointer">企业码下载</span>
          </div>
        </div>
      </div>
    </Modal>
    <Modal :closable="true" class="modal-setting modal-setting2" footer-hide title="" v-model="consultantModal.show"
           width="800px">
      <div class="w-full bg-white">
        <div class="h-50 w-full  flex a-center" style="background-color: #F7F9FD">
          <div class="bold fs-18 color-33" style="margin-left: 10px">您的专属顾问</div>
          <div class="flex-1 flex j-end">
            <Button class="  m-r-50" type="primary" value="视频讲解">视频讲解</Button>
          </div>
        </div>

        <div class="w-full h-full flex" style="height: 536px;">
          <div class=" card w-full h-full flex">
            <img class="w-full" src="../../assets/basesettings/img_guwen@2x.png"
                 style="height: 366px;align-self: center">

            <div class="flex flex-1  p-l-20 j-center"
                 style="flex-direction: column;">
              <div class="fs-16 bold color-33">
                张珊珊
              </div>
              <div class="fs-13 color-66 m-t-10">
                高级软件顾问
              </div>
            </div>
          </div>
          <div class="flex"
               style="height: 366px;margin-top:40px;flex-grow: 1;flex-direction: column;justify-content: center">
            <!--<div class="fs-18 bold color-33" style="margin-left: 55px">联系我</div>-->
            <!--】-->
            <div class="flex a-center">
              <img class="w-25 h-25" src="../../assets/basesettings/ic_phone2@2x.png">
              <span class="fs-18 bold color-33 m-l-30">133-8888-9999</span>
            </div>
            <div class="flex" style="margin-top: 45px;height: 1px">
              <img class="w-25 h-25" src="../../assets/basesettings/ic_weixin@2x.png"
                   style="align-self: start">
              <img class="m-l-30" src="../../assets/basesettings/img_qrcode@2x.png"
                   style="width: 108px;height: 108px">
            </div>
          </div>
        </div>
      </div>
    </Modal>

    <Modal :closable="false" :mask-closable="false" class="modal-setting modal-setting2" footer-hide title=""
           v-model="companyModal.show" width="680px">
      <ent-edit-widget :entInfo="entInfo" @cancel="companyModal.show=false"
                       @ok="companyModal.show = false"></ent-edit-widget>
    </Modal>

  </div>
</template>

<script>
import EntEditWidget from '../../components/common/EntEditWidget'
import {mapActions} from 'vuex'
import {handleSimpleDownload} from '../../utils/filedown'

export default {
  name: 'BaseSettings',
  components: {
    EntEditWidget,
  },
  data () {
    return {
      phoneVersionModal: {
        show: false,
        title: '手机版本',
      },
      consultantModal: {
        show: false,
      },
      companyModal: {
        show: false,
      },
      entInfo: {
        logo: '',
        entName: '',
        contact: '',
        phone: '',
        superName: '',
        webPage: ''
      }
    }
  },
  computed: {
    getQrCode () {
      return this.$store.state.company.switchEntQrcodeUrl || ''
    },
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      // this.getCurrentEntInfo()
    },
    toLoginAccounts () {
      this.$router.push('/loginaccounts')
    },
    onAccountEdit () {
      let company = this.$store.state.company
      let entName = company.entName || ''
      let logo = company.entLogo || ''
      let contact = ''
      let phone = ''
      this.entInfo = {
        logo,
        entName,
        contact,
        phone,
        superName: '张三',
        webPage: 'http://www.so.laodao.cn'
      }
      this.companyModal.show = true
    },
    onQrcodeDownload () {
      if (this.getQrCode) {
        handleSimpleDownload(this.getQrCode)
      }
    },
    ...mapActions([
      'getEntNavigations',
      'updateNavList',
      'getCurrentEntInfo'
    ])
  }
}
</script>

<style lang="scss" scoped>
  .modal-setting ::v-deep {
    //标题背景色
    .ivu-modal-header {
      background-color: #F7F9FD;
    }

    .ivu-modal-body {
      padding: 0;
      display: flex;
      justify-content: center;
      align-content: center;
    }

    //标题下横线
    .ivu-modal-header {
      border-bottom: none;
    }

    //确认取消按钮上面红线
    .ivu-modal-footer {
      border-top: none;
      //取消padding margin
      padding: 0;
      margin: 0;
    }
  }

  .modal-setting2 ::v-deep {
    .ivu-modal-header {
      display: none;
    }
  }

  .card {
    width: 300px;
    height: 460px;
    margin-left: 40px;
    margin-top: 40px;
    margin-right: 80px;
    flex-direction: column;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.24);
    border-radius: 8px;
  }
</style>
